export const SORT_FIELDS = {
  'campaign name': 'adname',
  status: 'status',
  'start date': 'startdate',
  'end date': 'enddate',
  budget: 'budget',
  reach: 'reach',
  'ads served': 'impressions',
};



// WEBPACK FOOTER //
// ./src/mappers/sort.js